import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetRenderQueueItemCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRenderQueueItemCountQuery = { __typename?: 'Query', getRenderQueueItemCount: number };


export const GetRenderQueueItemCount = /*#__PURE__*/ gql`
    query GetRenderQueueItemCount {
  getRenderQueueItemCount
}
    ` as unknown as DocumentNode<GetRenderQueueItemCountQuery, GetRenderQueueItemCountQueryVariables>;

          

          export const useGetRenderQueueItemCountQuery = (options?:QueryHookOptions<GetRenderQueueItemCountQuery, GetRenderQueueItemCountQueryVariables>) => useQuery(GetRenderQueueItemCount, options);

          

          export type GetRenderQueueItemCountQueryOptions = QueryHookOptions<GetRenderQueueItemCountQuery, GetRenderQueueItemCountQueryVariables>;

          

          export const useGetRenderQueueItemCountLazyQuery = (options?:LazyQueryHookOptions<GetRenderQueueItemCountQuery, GetRenderQueueItemCountQueryVariables>) => useLazyQuery(GetRenderQueueItemCount, options);

          

          export type GetRenderQueueItemCountQueryResult = ReturnType<typeof useGetRenderQueueItemCountQuery>;

          
